import * as arSA from './ar-SA';
import * as esES from './es-ES';
import * as esMX from './es-MX';
import * as enPH from './en-PH';
import * as enSG from './en-SG';
import * as enUS from './en-US';
import * as frFR from './fr-FR';
import * as heIL from './he-IL';
import * as jaJP from './ja-JP';
import * as koKR from './ko-KR';
import * as ptBR from './pt-BR';
import * as ruRU from './ru-RU';
import * as zhHK from './zh-HK';
import * as zhTW from './zh-TW';
import * as zhCN from './zh-CN';
export const locale = {
    'ar-SA': arSA,
    'es-ES': esES,
    'es-MX': esMX,
    'en-PH': enPH,
    'en-SG': enSG,
    'en-US': enUS,
    'fr-FR': frFR,
    'he-IL': heIL,
    'ja-JP': jaJP,
    'ko-KR': koKR,
    'pt-BR': ptBR,
    'ru-RU': ruRU,
    'zh-HK': zhHK,
    'zh-TW': zhTW,
    'zh-CN': zhCN,
};
